/*
 * Routine shopping list: [data-routine-add-all] adds every listed variant (comma-separated ids)
 * to the cart in one request, refreshes the cart drawer and opens it.
 */
(function () {
  if (window.__routineAddAll) return;
  window.__routineAddAll = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-routine-add-all]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const ids = (button.dataset.routineAddAll || '')
      .split(',')
      .map(function (id) { return Number(id); })
      .filter(Boolean);
    if (!ids.length) return;

    const wrapper = button.closest('[data-add-all-wrapper], .routine-curated__add-all');
    const message = wrapper ? wrapper.querySelector('[role="status"]') : null;
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender() : [];
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    if (message) message.textContent = '';

    try {
      const response = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: id, quantity: 1 }; }),
          sections: sections.map(function (s) { return s.id; }),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        if (message) message.textContent = data.description || data.message || 'Some items could not be added.';
        return;
      }

      if (drawer && data.sections) {
        sections.forEach(function (section) {
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          const html = data.sections[section.id];
          if (el && html && drawer.getSectionInnerHTML) el.innerHTML = drawer.getSectionInnerHTML(html, section.selector);
        });
        drawer.classList.remove('is-empty');
        const inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'routine-add-all' });
      }

      if (message) message.textContent = button.dataset.added || '';
      if (drawer && typeof drawer.open === 'function') drawer.open(button);
    } catch (e) {
      if (message) message.textContent = 'Some items could not be added. Please try again.';
    } finally {
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
    }
  });
})();
